import React, {lazy, useState} from "react";
import "./Layout.scss";
import { GlobalContext } from "../../contexts/GlobalContexts";
import AppRoutes from "../../routes/route";
import Loader from "../../components/loader/Loader";


const HeaderIndex = lazy(() =>
    import('../../features/header')
        .then(({HeaderIndex}) => ({default: HeaderIndex})),
);

const Footer = lazy(() =>
    import('../../features/footer/footer')
        .then(({Footer}) => ({default: Footer})),
);


const Layout = () => {

    const [globalContext,setGlobalContext] = useState<any>({
        interactedWithSideMenuOrSearch : false,
        isSearch : false,
        isLoading:false,
    });
    return (
        <>
                    <GlobalContext.Provider value = {{globalContext, setGlobalContext}} >
                        <div className="layout">
                            <React.Suspense>
                                <HeaderIndex/>
                            </React.Suspense>
                            <div className="layout-container">
                                <div className="layout-contents">
                                    <AppRoutes/>
                                    <React.Suspense>
                                         <Footer/>
                                    </React.Suspense>
                                </div>
                            </div>
                                    
                        </div>
                        {globalContext.isLoading ?<Loader/> :null}
                    </GlobalContext.Provider>
        </>
    );
}

export default Layout;
